export async function openBinary(apiPath) {
  try {
    const token = localStorage.getItem("ama_token");
    const url = `${process.env.REACT_APP_BACKEND_URL}/api${apiPath}`;
    const r = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
      cache: "no-store",
    });
    if (!r.ok) throw new Error("HTTP " + r.status);
    const blob = await r.blob();
    const u = URL.createObjectURL(blob);
    window.open(u, "_blank");
  } catch (e) {
    alert("Impossibile aprire il documento: " + e.message);
  }
}
